import { __assign } from 'tslib';
import React, { useRef } from 'react';
import { useIntl } from 'react-intl';
import { CloseIcon, SearchIcon } from '@panwds/icons';
import '../Icon/ImgIcon.esm.js';
import '../Icon/FaIcon.esm.js';
import { LoadingIcon } from '../Icon/SemanticIcons.esm.js';
import { Input } from '../Input/Input.esm.js';

var SearchInput = function (props) {
    var isLoading = props.isLoading, filter = props.filter, filterItems = props.filterItems, getInputProps = props.getInputProps;
    var intl = useIntl();
    var inputRef = useRef(null);
    return (React.createElement("div", { className: "tw-p-1" },
        React.createElement(Input, __assign({ tabIndex: -1, "data-testid": "search-input", placeholder: intl.formatMessage({ id: "oPXkY9", defaultMessage: [{ type: 0, value: "Search" }] }), suffix: React.createElement(React.Fragment, null,
                isLoading && React.createElement(LoadingIcon, null),
                filter ? (React.createElement("button", { "aria-label": intl.formatMessage({ id: "9/b2iN", defaultMessage: [{ type: 0, value: "Clear Filter" }] }), onClick: function () {
                        var _a;
                        filterItems();
                        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    }, className: "focus:tw-outline-none tw-box-border tw-border-0 tw-bg-transparent" },
                    React.createElement(CloseIcon, { size: "xxs", className: "tw-text-secondary dark:tw-text-dark-bg-secondary" }))) : (React.createElement(SearchIcon, { size: "sm", className: "tw-text-secondary dark:tw-text-dark-bg-secondary" }))) }, getInputProps({
            onChange: function (event) {
                var _a;
                filterItems((_a = event.target.value) !== null && _a !== void 0 ? _a : "");
            },
            ref: inputRef
        })))));
};

export { SearchInput };
//# sourceMappingURL=SearchInput.esm.js.map
